/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import makeRequest from 'utils/makeRequest';
import throttle from 'lodash.throttle';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import Link from 'components/Link';
import FlipCardAd from 'components_v2/common/FlipCardAd';
import { inViewForReact } from 'utils/common';
import s from './IPLWidget.scss';
// import LiveIcon from '../../../components_v2/common/InitNewscardComponents/LiveNowIcon';
import InViewObserver from '../../../components/InViewObserver/InViewObserver';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

class IPLWidgetV2 extends React.Component {
  constructor() {
    super();
    this.state = {
      data: {},
    };

    this.ref = React.createRef();
    this.iplRef = React.createRef();

    this.autoRefreshStarted = false;
  }

  componentDidMount() {
    const { dataUrl } = this.props;
    if (dataUrl) {
      this.getMatchesData(true);
      this.throttledGAonScroll = throttle(this.handleGAOnScroll, 100);
      window.addEventListener('scroll', this.throttledGAonScroll);

      if (this.props.autoRefresh) {
        this.refreshTimer = setInterval(
          this.getMatchesData,
          this.props.autoRefreshRate || 15000,
        );
      }
    }
  }

  removeScrollEvent = () => {
    if (typeof this.throttledGAonScroll === 'function') {
      window.removeEventListener('scroll', this.throttledGAonScroll);
    }
  };

  handleGAOnScroll = () => {
    if (
      this.iplRef &&
      this.iplRef.current &&
      inViewForReact(this.iplRef.current, 0, true)
    ) {
      const gaData = {
        gaCategory: 'WAP-Home',
        gaAction: 'Section_View-IPL2020',
        gaLabel: 'view',
      };
      this.sendGA(gaData);
      this.removeScrollEvent();
    }
  };

  componentWillUnmount() {
    if (this.timeoutVal) {
      clearTimeout(this.timeoutVal);
    }
    if (this.refreshTimer) clearInterval(this.refreshTimer);
    this.removeScrollEvent();
  }

  refreshData = autoUpadteTime => {
    if (autoUpadteTime) {
      this.timeoutVal = setTimeout(() => {
        this.getMatchesData();
        this.refreshData(autoUpadteTime);
      }, autoUpadteTime);
    }
  };

  sendGA = data => {
    sendGaThroughProps({
      data,
    });
  };

  getAndSetLiveMatchInView = () => {
    if (this.ref && this.ref.current) {
      try {
        const elem = this.ref.current.querySelector(`[data-matchindex="1"]`);
        if (elem) {
          const boundingData = elem.getBoundingClientRect();
          this.ref.current.scrollLeft =
            this.ref.current.scrollLeft + boundingData.left - 10;
        }
      } catch (e) {
        // console.log(e);
      }
    }
  };

  getMatchesData = setLiveMatchInView => {
    this.setState({
      refreshing: true,
    });

    setTimeout(() => {
      this.setState({
        refreshing: false,
      });
    }, 1000);

    const { dataUrl } = this.props;
    makeRequest.get(dataUrl).then(response => {
      const { data } = response;
      if (data && data.matches) {
        this.setState(
          {
            data,
          },
          () => {
            if (setLiveMatchInView && data && data.matches) {
              this.getAndSetLiveMatchInView();
            }
            if (typeof this.props.showMiniScoreCard === 'function') {
              const eventName =
                data.matches &&
                data.matches instanceof Array &&
                data.matches[0] &&
                data.matches[0].event
                  ? data.matches[0].event
                  : '';
              this.props.showMiniScoreCard(true, eventName);
            }
          },
        );

        if (
          data.autoUpadteTime &&
          // eslint-disable-next-line no-restricted-globals
          !isNaN(data.autoUpadteTime) &&
          !this.autoRefreshStarted
        ) {
          this.autoRefreshStarted = true;
          this.refreshData(parseInt(data.autoUpadteTime, 10));
        }
      }
    });
  };

  getRefreshButton = () => {
    const html =
      this.props.isWapView &&
      this.state?.data?.matches &&
      Array.isArray(this.state?.data?.matches) &&
      this.state?.data?.matches.length > 0 &&
      this.state?.data?.matches[0].scorecardLink ? (
        <>
          <Link
            className={`${s.liveScoreBtn}`}
            to={this.state?.data?.matches[0].scorecardLink}
            data-ga={this.props.gaData}
          >
            <div className={s.blinker}>
              <i className={`${s.liveBtn}`} />
              <span>LIVE</span>
            </div>
            {/* <LiveIcon text="Live Score" /> */}
          </Link>
          <a
            href={this.state?.data?.matches[0].scorecardLink}
            className={s.view_scorecard}
          >
            Scorecard
          </a>
        </>
      ) : (
        <button
          type="button"
          className={`${s.refreshBtn} ${this.state.refreshing ? s.active : ''}`}
          onClick={this.getMatchesData}
        />
      );
    return html;
  };
  getInnigsScore = score => {
    if (score && typeof score === 'string') {
      const scoreArr = score.split(' & ');
      const result = [];
      if (scoreArr && Array.isArray(scoreArr) && scoreArr.length > 0) {
        scoreArr.forEach(inngs => {
          if (inngs && typeof inngs === 'string') {
            const inngArr = inngs.split(' ');
            if (inngArr && Array.isArray(inngArr) && inngArr.length > 0) {
              result.push(inngArr[0]);
            }
          }
        });
      }
      return result;
    }
    return '';
  };
  getMatchCard = match => {
    const { team1, team2, scorecardLink, format } = match;
    const inningsMappings = ['1st', '2nd', '3rd', '4th'];
    let teamainngscore = [];
    let teambinngscore = [];
    const gaData = {
      gaCategory: this.props.gaCategory || 'IPL_WAP',
      gaAction: this.props.gaAction || 'IPL2021_scorecard',
      gaLabel: this.props.gaLabel || 'click_score',
    };
    const isTestMatch = !!(format && format === 'test');
    if (isTestMatch) {
      if (team1?.score?.score) {
        teamainngscore = this.getInnigsScore(team1?.score?.score);
      }
      if (team2?.score?.score) {
        teambinngscore = this.getInnigsScore(team2?.score?.score);
      }
    }
    const html = (
      <React.Fragment>
        <Link to={scorecardLink} target="_blank">
          <div className={`${s.flexbox} ${s.teamInfo}`}>
            <div
              className={`${s.flexbox} ${s.teamname} ${s.left} ${
                this.props.isPrimeUserLayout ? s.primelayout : ''
              }`}
            >
              {/* <Link to={team1.profileLink} target="_blank"> */}
              <div className={s.teamIconWrap}>
                <i className={`${s.icon} ${s[team1.name]} `} />
                <strong>{team1.name}</strong>
                {team1 && team1.highlight && <i className={s.batting_icon} />}
              </div>
              {/* </Link> */}
              <div
                className={`${s.scoreInfo} ${s.innings_wrap}  ${
                  this.props.isPrimeUserLayout ? s.primelayout : ''
                } ${
                  match.status && match.status.toLowerCase() === 'match ended'
                    ? s.matchend
                    : ''
                }`}
              >
                <h2
                  className={`${
                    team1.highlight &&
                    team1.highlight.toLowerCase() === 'yes' &&
                    match.status &&
                    (match.status.toLowerCase() === 'live' ||
                      match.status.toLowerCase() === 'super over')
                      ? s.highlight
                      : ''
                  } ${this.props.isPrimeUserLayout ? s.primelayout : ''} ${
                    isTestMatch ? s.testHighlight : ''
                  } `}
                >
                  {isTestMatch &&
                    teamainngscore &&
                    Array.isArray(teamainngscore) &&
                    teamainngscore.length > 0 &&
                    teamainngscore.map(inngs => (
                      <>
                        <div className={`${s.innings_score} innings_score `}>
                          {/* <span>{inningsMappings[index]} Inn:</span> */}
                          <span>{inngs}</span>
                        </div>
                      </>
                    ))}
                  {!isTestMatch && team1.score && team1.score.text1
                    ? team1.score.text1
                    : ''}
                </h2>
                <p>
                  {!isTestMatch && team1.score && team1.score.text2
                    ? `(${team1.score.text2})`
                    : ''}
                </p>
              </div>
            </div>
            <div className={s.live_score_btn}>
              {match.status === 'live' && !this.props.cardsLinkout ? (
                this.getRefreshButton()
              ) : (
                <span
                  className={`${s.status} ${s[match.status]}`}
                  title={match.status}
                >
                  {match.status}
                </span>
              )}
              <div className={`${s.superovercount} superovercount`}>
                {team1.score && team1.score.text3
                  ? team1.score.text3
                  : team2.score && team2.score.text3 ? team2.score.text3 : ''}
              </div>
            </div>
            <div
              className={`${s.flexbox} ${s.teamname} ${s.right} ${
                this.props.isPrimeUserLayout ? s.primelayout : ''
              }`}
            >
              {/* <Link to={team2.profileLink} target="_blank"> */}
              <div className={s.teamIconWrap}>
                {team2 && team2.highlight && <i className={s.batting_icon} />}
                <strong>{team2.name}</strong>
                <i className={`${s.icon} ${s[team2.name]} `} />
              </div>
              {/* </Link> */}
              <div
                className={`${s.scoreInfo} ${s.innings_wrap} ${
                  this.props.isPrimeUserLayout ? s.primelayout : ''
                } ${match.status === 'Match Ended' ? s.matchend : ''}`}
              >
                <h2
                  className={`${
                    team2.highlight &&
                    team2.highlight.toLowerCase() === 'yes' &&
                    match.status &&
                    (match.status.toLowerCase() === 'live' ||
                      match.status.toLowerCase() === 'super over')
                      ? s.highlight
                      : ''
                  }
                      ${this.props.isPrimeUserLayout ? s.primelayout : ''}
                      ${isTestMatch ? s.testHighlight : ''} `}
                >
                  {isTestMatch &&
                    teambinngscore &&
                    Array.isArray(teambinngscore) &&
                    teambinngscore.length > 0 &&
                    teambinngscore.map(inngs => (
                      <>
                        <div className={`${s.innings_score} innings_score `}>
                          {/* <span>{inningsMappings[index]} Inn:</span> */}
                          <span>{inngs}</span>
                        </div>
                      </>
                    ))}
                  {!isTestMatch && team2.score && team2.score.text1
                    ? team2.score.text1
                    : ''}
                </h2>
                <p>
                  {!isTestMatch && team2.score && team2.score.text2
                    ? `(${team2.score.text2})`
                    : ''}
                </p>
              </div>
            </div>
          </div>
        </Link>
      </React.Fragment>
    );

    return (
      <React.Fragment>
        {(match.status === 'live' &&
          this.props.cardsLinkout &&
          match.scorecardLink) ||
        (match.status !== 'upcoming' && match.status !== 'live') ? (
          <Link
            to={match.scorecardLink}
            className={s.content}
            data={gaData}
            data-matchindex={match.default === 'true' ? '1' : '-1'}
          >
            {html}
          </Link>
        ) : (
          <div className={s.content} onClick={() => this.sendGA(gaData)}>
            {html}
          </div>
        )}
      </React.Fragment>
    );
  };

  renderMatchCard = () => {
    const { data } = this.state;
    const { matches, footerData } = data;
    return (
      <InViewObserver
        inViewCallback={() => {
          if (this.props.gaViewData) {
            analyticsWrapper('ga', 'send', 'event', ...this.props.gaViewData);
          }
        }}
        className={this.props.wrapperClass}
      >
        <div
          className={`${s.iplwidget} ${s.scorecard_v2} ${this.props
            .isStickyCard && s.whtscorecard} ${
            this.props.isPrimeUserLayout ? s.primelayout : ''
          }`}
          ref={this.iplRef}
        >
          <h2>{data.title}</h2>
          <div
            ref={this.ref}
            className={`${s.widget} ${s.liveScorecard} ${
              this.props.theme ? s[this.props.theme] : ''
            }`}
          >
            {matches &&
              matches.length > 0 &&
              matches.map(match => (
                <React.Fragment key={match.matchNo}>
                  {this.getMatchCard(match)}
                </React.Fragment>
              ))}
          </div>
          {footerData &&
            footerData.length > 0 && (
              <div className={s.ipllinks}>
                {footerData.map(val => (
                  <Link
                    key={val.name}
                    to={val.url}
                    className={s[val.name]}
                    data={{
                      gaCategory: 'IPL2020_scorecard',
                      gaAction: `click_${val.gaLabel || ''}`,
                      gaLabel: 'https://m.timesofindia.com/',
                    }}
                  >
                    {val.name === 'stats' ? 'Standings' : val.name}
                  </Link>
                ))}
              </div>
            )}
        </div>
      </InViewObserver>
    );
  };

  render() {
    if (
      !(
        this.state.data &&
        this.state.data.matches &&
        this.state.data.matches.length > 0
      )
    ) {
      return null;
    }

    const { flipAd } = this.props;
    if (flipAd) {
      return (
        <FlipCardAd
          height="60px"
          width="100%"
          upsidedown
          isFlipActive
          msid={this.props.msid}
        >
          {this.renderMatchCard()}
        </FlipCardAd>
      );
    }
    return this.renderMatchCard();
  }
}

IPLWidgetV2.propTypes = {
  theme: PropTypes.string,
  sponsorAd: PropTypes.shape({}),
  autoRefresh: PropTypes.bool,
  autoRefreshRate: PropTypes.number,
  // setFallback: PropTypes.func,
  showMiniScoreCard: PropTypes.func,
  dataUrl: PropTypes.string.isRequired,
  cardsLinkout: PropTypes.bool,
  flipAd: PropTypes.bool,
  wrapperClass: PropTypes.string,
  msid: PropTypes.string,
  isPrimeUserLayout: PropTypes.bool,
};

IPLWidgetV2.defaultProps = {
  theme: '',
  sponsorAd: undefined,
  showMiniScoreCard: undefined,
  cardsLinkout: false,
  autoRefresh: false,
  autoRefreshRate: undefined,
  flipAd: false,
  wrapperClass: '',
  msid: '',
  isPrimeUserLayout: false,
  // setFallback: () => {},
};

export default IPLWidgetV2;
